import { useState } from 'react'
import { COLOR } from '../../constant'
import { CloseCircleOutlined } from '@ant-design/icons'

const MobileViewInfo = () => {
  const [showInfo, setShowInfo] = useState(true)

  const handleClose = () => {
    setShowInfo(false)
  }

  return (
    <>
      {showInfo && (
        <div
          className='mobile-info-bar'
          // style={{
          //   width: '100vw',
          //   position: 'fixed',
          //   bottom: '0',
          //   left: '0',
          //   background: COLOR.CARRET,
          //   color: COLOR.DARK,
          // }}
        >
          For the best experience, we recommend using our desktop site. Some features may display better on a larger
          screen.
          <button onClick={handleClose}><CloseCircleOutlined /></button>
        </div>
      )}
    </>
  )
}

export default MobileViewInfo
